module.exports = __webpack_public_path__ + "img/Dailywork.ec439741.svg";